import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Row, Col, Form } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { toast } from 'react-toastify';
import { Utils } from '../../../core/utils';
import { ViewManager } from '../../../core/view-manager';



export default function DGSH_customer_order({ data, setData, selectedRows, setSelectedRows, refreshData }) {

    const navigate = useNavigate();

    async function createInvoice() {

        var arrayRows = [];
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            { fieldName: "id", type: "in", value: selectedRows.toString() }
        ]
        var resOrder = await DataManager.searchItems('customer_order', 1, 100, sorting, '', [], constraints);
        if (resOrder.success === 1) {
            const checkCustomer = resOrder.body.every(item => item.idCustomer && item.idCustomer.id === resOrder.body[0].idCustomer.id);
            const checkAgent = resOrder.body.every(item => item.idSalesAgent && item.idSalesAgent.id === resOrder.body[0].idSalesAgent.id);
            const checkPayment = resOrder.body.every(item => item.idPaymentCondition && item.idPaymentCondition.id === resOrder.body[0].idPaymentCondition.id);
            const checkDelivery = resOrder.body.every(item => item.address && item.address.id === resOrder.body[0].address.id);

            if (checkCustomer === false) {
                toast.error('Impossibile generare i documenti perché gli ordini selezionati non hanno lo stesso CLIENTE.', { theme: 'colored' })
            }
            if (checkAgent === false) {
                toast.error('Impossibile generare i documenti perché gli ordini selezionati non hanno lo stesso AGENTE.', { theme: 'colored' })
            }
            if (checkPayment === false) {
                toast.error('Impossibile generare i documenti perché gli ordini selezionati non hanno la stessa CONDIZIONE DI PAGAMENTO.', { theme: 'colored' })
            }
            if (checkDelivery === false) {
                toast.error('Impossibile generare i documenti perché gli ordini selezionati non hanno lo stesso INDIRIZZO DI CONSEGNA.', { theme: 'colored' })
            }
            if (checkCustomer === true && checkAgent === true && checkPayment === true && checkDelivery === true) {
                console.log(resOrder.body)
                for (let i = 0; i < resOrder.body.length; i++) {
                    for (let j = 0; j < resOrder.body[i].rows.length; j++) {
                        arrayRows.push(resOrder.body[i].rows[j])
                    }
                }
                console.log(arrayRows)



                var finalRows = [];
                for (let a = 0; a < arrayRows.length; a++) {
                    var rows = {
                        idCustomerOrder: arrayRows[a].idCustomerOrder || null,
                        idCustomerOrderRow: arrayRows[a].id || null,
                        riferimentoDDT: "",
                        idFather: "",
                        codeFather: "",
                        qtaFather: "",
                        idItemModel: arrayRows[a].idItemModel.id || null,
                        codeItemModel: arrayRows[a].idItemModel.code || null,
                        nameItemModel: arrayRows[a].idItemModel.name || null,
                        priceItemModel: arrayRows[a].price || null,
                        discount: "",
                        ivaItemModel: arrayRows[a].idVatCondition.percentage || null,
                        quantity: arrayRows[a].quantity,
                        fulfilledQuantity: arrayRows[a].fulfilledQuantity,
                        quantityUnloaded: "0",
                        packages: arrayRows[a].packages,
                        status: { value: '0_PENDING' },
                        totalRow: arrayRows[a].totalRow,
                        totalIva: arrayRows[a].totalIva,
                        total: arrayRows[a].total,
                    }
                    finalRows.push(rows)
                }

                var body = {
                    rows: finalRows,
                    documentType: { value: 0 },
                    idCustomer: resOrder.body[0].idCustomer.id,
                    nameCustomer: resOrder.body[0].idCustomer.name,
                    address: resOrder.body[0].address,
                    phoneCustomer: resOrder.body[0].idCustomer.phone,
                    vatNumberCustomer: resOrder.body[0].idCustomer.vatNumber,
                    orderNumber: resOrder.body[0].internalCode,
                    incotermsCustomer: resOrder.body[0].idIncoterms.name,
                    idAgent: resOrder.body[0].idSalesAgent.id,
                    idPaymentCondition: resOrder.body[0].idPaymentCondition.id,
                    paymentConditionCustomer: resOrder.body[0].idPaymentCondition.name,
                    bankCustomer: resOrder.body[0].idCustomer.idBank && resOrder.body[0].idCustomer.idBank.name || "",
                    abi: resOrder.body[0].idCustomer.idBank && resOrder.body[0].idCustomer.idBank.abi || "",
                    cab: resOrder.body[0].idCustomer.idBank && resOrder.body[0].idCustomer.idBank.cab || "",
                    iban: resOrder.body[0].idCustomer.iban || "",
                    idCustomerOffice: resOrder.body[0].address && resOrder.body[0].address.id || "",
                    addressCustomerOffice: "",
                    phoneCustomerOffice: resOrder.body[0].address && resOrder.body[0].address.phone || "",
                    externalCode: resOrder.body[0].externalCode || "",
                    transportReason: "VENDITA",
                    nameForwarder: "",
                    packagesQuantity: "",
                    weight: "",
                    volume: "",
                    itemsAspect: "",
                    transportBy: { value: '1_RECIPIENT' },
                    status: { value: '0_PENDING' },
                    totalImballo: resOrder.body[0].totalImballo || "",
                    costSpedizione: resOrder.body[0].costSpedizione || "",
                    idVatConditionSpedizione: resOrder.body[0].idVatConditionSpedizione && resOrder.body[0].idVatConditionSpedizione.id || "",
                    costIncasso: resOrder.body[0].costIncasso || "",
                    idVatConditionIncasso: resOrder.body[0].idVatConditionIncasso && resOrder.body[0].idVatConditionIncasso.id || "",
                    abbuono: resOrder.body[0].abbuono || "",
                    totalImponibile: resOrder.body[0].totalImponibile || "",
                    totalIva: resOrder.body[0].totalIva || "",
                    totalPrice: resOrder.body[0].totalPrice || "",
                    notes: resOrder.body[0].notesInternal
                }
                console.log(body)

                var response = await DataManager.insertItem('customer_invoices', body);
                console.log(response)
                if (response.success === 1) {
                    toast.success('Fattura creata con successo!', { theme: 'colored' })
                } else {
                    toast.error('Errore nella creazione della fattura!', { theme: 'colored' })
                }
            }

        }


    }


    return (
        <>
            <Row>
                <Col md={12} xs={6} className='pe-0 my-2'>
                    <Button variant='success' size='sm' className='w-100' onClick={() => createInvoice()}>Crea Documento</Button>
                </Col>
            </Row>
        </>
    )
};